module.exports = __webpack_public_path__ + "static/img/8.8b4a24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/8.png
// module id = qRmk
// module chunks = 4